import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class MicroFinanceCenterService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'microfinancecenter/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  getAll(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'microfinancecenter').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  get(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'microfinancecenter/customer').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `microfinancecenter/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createCenter(microFinanceCenter: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'microfinancecenter', microFinanceCenter).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(microFinanceCenter: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'microfinancecenter', microFinanceCenter).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(microFinanceCenter: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'microfinancecenter/authorise', microFinanceCenter).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `microfinancecenter/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getPigmyAgentAccounts(agentId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `microfinancecenter/agent/${agentId}
    `).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getDropdown(branchId?: number): Observable<any> {
    let url = this.baseApiUrl + 'microfinancecenter/dropdown';
    if (branchId != null && branchId > 0) {
      url += `?branchId=${branchId}`;
    }
    return this.httpClient.get(url).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  
}